import { AbstractControl, ValidationErrors } from '@angular/forms';


export function currentYear() {
  return new Date(Date.now()).getFullYear();
}

export function getCurrentFiscalYear(): string {
  const now = new Date();
  const fyStartYear = now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
  return `FY${String(fyStartYear).slice(-2)}`;
}

/*
 * to use when creating a new object (omitting the 'id')
 * */
export type New<T> = T extends { id: string | number } ? Omit<T, 'id'> : T;

export function enumToSelectOptions<T extends { [key: string | number]: string | number }>(e: T) {
  return Object.entries(e).map(([value]) => ({ label: value, value }));
}

export function formatCamelCase(status: string): string {
  return status.replace(/([A-Z])/g, ' $1').trim();
}

export function formatLabel(label: string): string {
  return label.toLowerCase().replace(/_/g, ' ').replace(/\b[a-z]/g, c => c.toUpperCase());
}

export function stringToObject(param: string[]) {
  let res: { label: string; value: string; disabled: boolean }[] = [];
  param.forEach((string) => {
    res.push({ label: string, value: string, disabled: false });
  });
  return res;
}

export function calculateDuration(startDate: string, endDate: string): string {
  const start = new Date(startDate);
  const end = new Date(endDate || Date.now());

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();
  let days = end.getDate() - start.getDate();

  if (days < 0) {
    months--;
    days += new Date(end.getFullYear(), end.getMonth(), 0).getDate();
  }
  if (months < 0) {
    years--;
    months += 12;
  }

  return [
    years > 0 ? `${years} year${years > 1 ? 's' : ''}` : '',
    months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '',
    `${days} day${days > 1 || days == 0 ? 's' : ''}`,
  ]
    .filter(Boolean)
    .join(' ');
}

export function setPrecision(value: number, precision: number): string {
  return value?.toFixed(precision);
}

export function labelValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    
    if (!value) {
      return { required: true };
    }

    if (/\s{2,}/.test(value)) {
      return { multipleSpaces: true };
    }

    if (!/[A-Za-z]/.test(value)) {
      return { missingLetter: true };
    }

    if (!/^[A-Za-z0-9.+# ]+$/.test(value)) {
      return { invalidCharacters: true };
    }

    return null;
  }